
const ua = navigator.userAgent
const isAndroidApp = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;

import { Options, Vue } from "vue-class-component";
import { getCollectionIds, getCollectionDetailByIds } from "@/api/index";
import mobileNativeSDK from '@/assets/js/mobileNativeSDK.js'
import QuestionDetail from "../../components/QuestionDetail.vue"
import NoData from "../../components/NoData.vue"
import Rocket from "../../components/Rocket.vue"
import { isNewBridgeView } from '@/assets/js/utils.js'
import { getClientCommonMessage } from '@/utils/nativeFn'
import { getCurrentInstance } from "vue";
@Options({
  components: { 
    QuestionDetail,
    NoData,
    Rocket
  },
})
export default class CollectionIndex extends Vue {
  $store
  $router
  questionData: any[] = [] // 题目列表
  questionIds: string[] = []
  lists: any[] = [] 
  totalNum: any = ''
  bottomTxt: string = ''
  loading: boolean = false
  finished: boolean = false
  hasAjaxData: boolean = false
  scrollTop: number = 0
  isShowRocket: boolean = false
  hasDetailAndroidMsg: boolean = false
  queryDone: boolean = false
  $xesLog = getCurrentInstance()?.appContext.config.globalProperties.$xesLog
  mounted() {
    // this.getCollectionIds()
    if (isNewBridgeView()) {
      this.initNewData()
    } else {
      this.getNativeData();
      window['$eventBus'].addListener('receiveAndroidMsg', this.receiveAndroid);
    }
    window.addEventListener("scroll", this.listenerScroll, true);
        // pv
    this.$xesLog.view('favorite_notebook_pv', {
      event_type: 'pv',
      source_location: 'my_page',
      event_name: '收藏夹pv',
      biz_name:'int_lear',
      page_name:'favorite_notebook'
    })
  }
  beforeUnmount() {
    window.removeEventListener("scroll", this.listenerScroll, true);
  }
  // 新的dsbridge初始化
  initNewData() {
    // 监听题目切换
    this.getNewNativeData()
    let num = 0
    let timer = setInterval(() => {
      if(this.queryDone) {
        clearInterval(timer)
        return
      } else {
        this.getNewNativeData()
        num++
        if (num === 10) {
          clearInterval(timer)
          this.getCollectionIds()
        }
      }
    }, 500)
  }
  // 新端获取数据
  getNewNativeData() {
    if (this.queryDone) {
        return
    }
    getClientCommonMessage({}, (res) => {
      console.log(res.token,'h5调用端上getClientCommonMessage')
      res.token && localStorage.setItem('tal_token', res.token)
      res.user_id && localStorage.setItem('TAL_UID_TMP', res.user_id)
      res.services_version = localStorage.setItem('service_version', res.service_version)
      this.queryDone = true
      // 获取到端上数据之后开始调用接口
      this.getCollectionIds()
    })
  }
  // 返回顶部
  goTop() {
    // 点击埋点
    this.$xesLog.track('favorite_notebook_click', {
      event_type: 'click',
      back_top: 'back_top',
      event_name: '收藏夹-功能点击',
      page_name:'favorite_notebook',
      biz_name:'int_lear', 
    })
    var timer = setInterval(function () {
      let osTop = document.documentElement.scrollTop || document.body.scrollTop;
      let ispeed = Math.floor(-osTop / 5);
      document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
      this.isTop = true;
      if (osTop === 0) {
        clearInterval(timer);
      }
    }, 30);
  }
  // 安卓监听消息
  receiveAndroid(res) {
    console.log('收到传递过来的安卓消息=====> ', typeof res)
    if (this.hasDetailAndroidMsg) {
      return
    }
    this.hasDetailAndroidMsg = true
    let androidResult: any = JSON.parse(res)
    if (androidResult.event == 'getData') {
      this.detailNativeData(androidResult.dataJson)
    }
  }
  // 从端上获取数据
  getNativeData() {
    mobileNativeSDK.getData((res) => {
      if (!isAndroidApp) {
        console.log(res, '11111')
        this.detailNativeData(res)
      }
    })
  }
  // 处理端上数据
  detailNativeData(res) {
    if (localStorage.getItem('tal_token') !== res.token) {
      localStorage.setItem('tal_token', res.token)
    }
    this.getCollectionIds();
  }
  // 监听滚动
  listenerScroll() {
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    let clientHeight = document.documentElement.clientHeight;
    let scrollHeight = document.documentElement.scrollHeight;
    let bottomOfWindow = scrollTop + clientHeight >= scrollHeight - 4
    if (scrollTop != 0 && bottomOfWindow && !this.loading && !this.finished) {
      this.getCollectionDetailByIds()
    }
    this.scrollTop = scrollTop;
    if (scrollTop > clientHeight) {
      this.isShowRocket = true;
    } else {
      this.isShowRocket = false;
    }
  }
  // 跳转详情页
  linkDetails(question) {
    // 点击埋点
    this.$xesLog.track('favorite_notebook_click', {
      event_type: 'click',
      exercise_click: 'exercise_click',
      event_name: '收藏夹-功能点击',
      page_name:'favorite_notebook',
      biz_name:'int_lear', 
    })
    localStorage.setItem('current_id', question.nry_question_id)
    this.$router.push({
      name: 'CollectionDetail',
    })
  }
  // 获取收藏的题目ids列表
  async getCollectionIds() {
    await getCollectionIds().then((res) => {
      if (res.data.code !== 0) {
        this.hasAjaxData = true
        this.$dialog.alert({
          message: res.data.message,
          confirmButtonText: '我知道了'
        })
        return
      }
      this.lists = res.data.data.list
      this.totalNum = res.data.data.total
      if (!this.lists || this.lists.length === 0) {
        this.hasAjaxData = true
        return
      }
      let temp = []
      this.lists.forEach(item => {
        this.questionIds.push((item as any).nry_question_id);
        temp.push((item as any).nry_question_id);
      })
      this.$store.commit('SET_QUESTION_IDS', temp);
    })
    this.getCollectionDetailByIds()
  }
  // 根据题目ids获取题目详情列表
  getCollectionDetailByIds() {
    if (this.loading) {
      return
    }
    if (this.questionIds.length > 0) {
      let nry_question_ids = this.questionIds.splice(0, 10)
      let data = {
        nry_question_ids
      }
      this.loading = true
      getCollectionDetailByIds(data).then((res) => {
        this.loading = false
        this.hasAjaxData = true
        if (res.data.code !== 0) {
          this.questionIds = nry_question_ids.concat(this.questionIds)
          this.$dialog.alert({
            message: res.data.message,
            confirmButtonText: '我知道了'
          })
          return
        }
        this.questionData = this.questionData.concat(res.data.data.list)
        this.$store.commit('SET_QUESTION_DATA', this.questionData)
        if (nry_question_ids.length < 10) {
          this.finished = true
        }
      }).catch((err) => {
        this.hasAjaxData = true
        this.loading = false
        console.log('加载列表详情失败：', err)
        this.questionIds = nry_question_ids.concat(this.questionIds)
      })
    }
  }
}
